<div class="p-6">
  <div class="max-w-2xl mx-auto">
    <p-card header="Photobooth Approval">
      @if (state() === 'loading') {
        <div class="flex flex-col gap-3 items-center py-8">
          <div class="text-gray-600 font-semibold">Approving photo…</div>
        </div>
      } @else if (state() === 'success') {
        <div class="flex flex-col gap-3 items-center py-8">
          <div class="text-green-700 font-bold text-lg">Approved</div>
          <div class="text-gray-600">You can close this tab.</div>
        </div>
      } @else {
        <div class="flex flex-col gap-3 items-center py-8">
          <div class="text-red-700 font-bold text-lg">Error</div>
          <div class="text-gray-600 text-center">{{ errorMessage() }}</div>
        </div>
      }
    </p-card>
  </div>
</div>

